import { render, staticRenderFns } from "./DashboardInfoTile.vue?vue&type=template&id=4175b0aa&scoped=true&"
import script from "./DashboardInfoTile.vue?vue&type=script&lang=js&"
export * from "./DashboardInfoTile.vue?vue&type=script&lang=js&"
import style0 from "./DashboardInfoTile.vue?vue&type=style&index=0&id=4175b0aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4175b0aa",
  null
  
)

export default component.exports